
import { LayoutCrearDoc } from "../../layouts";
import { useTodosProductos } from "../../../hooks/cache";
import { CargandoMedio } from "../../components";
import { useNavigate } from "react-router-dom";
import { BuscadorXTermino } from "../../components/buscadores";
import { TablaProductos } from "../components/TablaProductos";




export const ListadoProductos = () => {


    const navigate = useNavigate();
    const { data, isLoading, page, termino, chagePage, chageTermino } = useTodosProductos();


    const handleNavegar = () => {
        navigate(`/super/crearProducto`);
    }

    

    return (

        <LayoutCrearDoc titulo='Listado de Productos' funcion={ handleNavegar }>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de productos..." />
            :   <>
                <BuscadorXTermino mT={3} termino={termino} chageTermino={chageTermino} texto="producto" playhol="nombre codigo categoria" />
                <TablaProductos data={data || []} chagePage={chagePage} page={page} />
                </>
            }
        </LayoutCrearDoc>

    )
}
